// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"806":"user","933":"auth","945":"dashboard","962":"home"}[chunkId] || chunkId) + "." + {"399":"94302fd9","705":"fc92a998","806":"79ea3cb7","933":"cee8b6d9","945":"c841f24b","962":"d7736f86"}[chunkId] + ".js";
};